import type { DatasetsMutatorCreateDatasetProps } from "./datasets-mutator-create-dataset.type";

import { useDatasetsMutatorCreateDataset } from "./datasets-mutator-create-dataset.hook";

const DatasetsMutatorCreateDataset = (
  props: DatasetsMutatorCreateDatasetProps
) => {
  useDatasetsMutatorCreateDataset(props);

  return null;
};

export default DatasetsMutatorCreateDataset;
